import React from "react";
import {
  Box,
  HStack,
  VStack,
  Flex,
  Center,
  Button,
  Text,
  Stack,
} from "@chakra-ui/react";
import { useContaxt } from "../../context/Context";

export function ConsentPopUp({
  openSettings,
  openDatasecruity,
  saveAllCookies,
  saveOnlyNecessary,
}) {
  const { color, variant } = useContaxt();

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bgColor={"rgba(12, 31, 44, 0.95)"}
      backdropFilter="blur(15px)"
      borderTop={`2px solid ${color.mainColor}`}
      p={6}
      zIndex={9999}
      boxShadow="0 -8px 32px rgba(0, 0, 0, 0.4)"
    >
      <Flex direction={{ base: "column", md: "row" }} align="center" gap={6}>
        <HStack spacing={4} flex={1} align="start">
          {variant !== "base" && (
            <Center
              p={3}
              bg={`${color.mainColor}20`}
              borderRadius="16px"
              width={"64px"}
              aspectRatio={"1/1"}
              border={`2px solid ${color.mainColor}40`}
              fontSize="28px"
              lineHeight={0.5}
              color={color.mainColor}
            >
              🍪
            </Center>
          )}
          <VStack spacing={2} align={"start"} flex={1}>
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight="600"
              textAlign={"left"}
              color="white"
              lineHeight="1.3"
            >
              Wir respektieren deine Privatsphäre
            </Text>
            <Text
              textAlign={"left"}
              fontSize={{ base: "sm", md: "md" }}
              color="rgba(255, 255, 255, 0.8)"
              lineHeight="1.5"
              maxW="600px"
            >
              Wir verwenden Cookies und ähnliche Technologien, um dir das
              bestmögliche Erlebnis auf unserer Website zu bieten. Einige davon
              sind essenziell für den Betrieb der Seite, während andere uns
              helfen, diese Website und deine Erfahrung zu verbessern.
            </Text>
          </VStack>
        </HStack>

        {/* Action Buttons */}
        <VStack spacing={3} minW={{ base: "full", md: "300px" }}>
          <HStack spacing={3} w="full">
            <Button
              onClick={saveAllCookies}
              color="white"
              fontWeight="600"
              fontSize="sm"
              h="48px"
              flex={1}
              transition="all 0.3s ease"
              bg={color.mainColor}
              _hover={{
                bg: `${color.mainColor}E6`,
                transform: "translateY(-1px)",
                boxShadow: `0 4px 12px ${color.mainColor}40`,
              }}
              borderRadius="12px"
            >
              Alle akzeptieren
            </Button>
            <Button
              onClick={saveOnlyNecessary}
              bg="transparent"
              color="white"
              fontWeight="500"
              fontSize="sm"
              h="48px"
              flex={1}
              border={`2px solid ${color.secondButton}`}
              _hover={{
                bg: `${color.secondButton}20`,
                borderColor: "white",
                transform: "translateY(-1px)",
              }}
              transition="all 0.3s ease"
              borderRadius="12px"
            >
              Nur notwendige
            </Button>
          </HStack>
          <HStack spacing={4} justify="center" w="full">
            <Text
              fontSize="sm"
              color="rgba(255, 255, 255, 0.7)"
              cursor="pointer"
              onClick={openSettings}
              _hover={{
                color: color.mainColor,
                textDecoration: "underline",
                transform: "translateY(-1px)",
              }}
              transition="all 0.3s ease"
              fontWeight="500"
            >
              Einstellungen anpassen
            </Text>
            <Box
              w="2px"
              h="16px"
              bg={`${color.mainColor}60`}
              borderRadius="1px"
            />
            <Text
              fontSize="sm"
              color="rgba(255, 255, 255, 0.7)"
              cursor="pointer"
              onClick={openDatasecruity}
              _hover={{
                color: color.mainColor,
                textDecoration: "underline",
                transform: "translateY(-1px)",
              }}
              transition="all 0.3s ease"
              fontWeight="500"
            >
              Mehr erfahren
            </Text>
          </HStack>
        </VStack>
      </Flex>
    </Box>
  );
}
